import Vue from 'vue';
import VModal from 'vue-js-modal/dist/index.nocss'
import 'vue-js-modal/dist/styles.css'

Vue.use(VModal)